import { render } from "./file-document.vue?vue&type=template&id=9005a514"
import script from "./file-document.vue?vue&type=script&lang=js"
export * from "./file-document.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__